import { render } from "./ObjectConfig.vue?vue&type=template&id=271ce1f6&scoped=true&ts=true"
import script from "./ObjectConfig.vue?vue&type=script&lang=ts"
export * from "./ObjectConfig.vue?vue&type=script&lang=ts"

import "./ObjectConfig.vue?vue&type=style&index=0&id=271ce1f6&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271ce1f6"]])

export default __exports__